var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',[_c('a-col',{attrs:{"span":6}},[_c('p',[_vm._v("Hub message is disconnected")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }